import type { CopyShape } from "@tami/core/intl";

import type { DASHBOARD_SCRIPT_COPY_PT_BR } from "../dashboard-script.copy";

export const DASHBOARD_SCRIPT_COPY_EN_US: CopyShape<typeof DASHBOARD_SCRIPT_COPY_PT_BR> = {
  dashIntro: {
    narrative: "Your dashboard brings together performance, routine and deliverables — everything that matters for your creator career.",
  },
  dashGreeting: {
    narrative:
      "Start the day knowing exactly what you need to post, deliver and sort out — without opening five different apps.",
    callout: "Good morning, Ana! Here's your day at a glance.",
  },
  dashOverview1: {
    narrative: "Fewer spreadsheets, less chaos — more time to create.",
  },
  dashSocial: {
    narrative: "Track your engagement rate and follower growth on every network, always up to date.",
    callout: "Instagram, TikTok and YouTube connected — followers and engagement side by side.",
  },
  dashOverview2: {
    narrative: "Easy-to-read charts showing how your weeks performed.",
  },
  dashKpis: {
    narrative: "Revenue, active campaigns, pending deliverables and overall engagement — tracked automatically for you.",
    callout: "This month's KPIs in real time: revenue, campaigns, deliverables and engagement.",
  },
  dashOverview3: {
    narrative: "Understand how you're performing week over week, no guesswork.",
  },
  dashPosts: {
    narrative: "Get a clear list of what needs to go up today and this week — with time, platform and format.",
    callout: "Brand deals and organic kept separate: know what goes live today and what's coming this week.",
  },
  dashAgenda: {
    narrative: "Today's meetings, shoots and appointments built into your routine — nothing scattered around.",
    callout: "Today's schedule in sync: calls, shoots and deliverables in one place.",
  },
};
